<template lang="pug">
d2-container
  el-form(:inline="true" :model="searchData" size="mini")
    el-row(:span="24")
      el-col(:md="6" :sm="12")
        el-form-item(label="直播名称：")
          el-input(style="width: 210px;" v-model="searchData.liveName" placeholder="请输入直播名称" clearable)
    el-row(style="padding-bottom: 15px;" :span="24")
      el-col(:md="10" :sm="5")
          el-button(type="primary" @click="addOrUpdateHandle()") 新建直播
      el-col( :md="14" :sm="14" style="float: right;")
          div(style="float: right; display: flex;")
            el-button(type="primary" icon="el-icon-search" @click="queryList") 查 询
  el-table(:data="tableData" style="width: 100%;" v-loading="tableLoading" border)
    //- el-table-column(type="selection" header-align="center" align="center" width="50")
    el-table-column(prop="businessCode" header-align="center" align="center" label="比赛ID" width="160")
      template(slot-scope="scope")
        font.live-name(style="padding: 0;" @click="goCompetition(scope.row.competition.matchId, scope.row.competition.matchType)") {{ scope.row.businessCode }}
    el-table-column(prop="liveName" header-align="center" align="center" label="直播名称")
    el-table-column(prop="streamName" header-align="center" align="center" label="直播频道" width="80")
    el-table-column(prop="streamStartTime" header-align="center" align="center" label="开始时间" width="140")
    el-table-column(prop="streamEndTime" header-align="center" align="center" label="结束时间" width="140")
    el-table-column(prop="obsServer" header-align="center" align="center" label="OBS服务器" width="220")
      template(slot-scope="scope")
        font {{ scope.row.obsServer }}
        el-button(type="text" style="padding: 0;" @click="copyCode(scope.row.obsServer)") 点击复制
    el-table-column(prop="obsPushCode" header-align="center" align="center" label="OBS推流码" width="480")
      template(slot-scope="scope")
        font {{ scope.row.obsPushCode }}
        el-button(type="text" style="padding: 0;" @click="copyCode(scope.row.obsPushCode)") 点击复制
    el-table-column(prop="status" header-align="center" align="center" label="状态" width="70")
      template(slot-scope="scope")
        font(v-if="scope.row.status === 10") 未发布
        font(v-if="scope.row.status === 20") 已发布
        font(v-if="scope.row.status === 30") 已下播
    el-table-column(header-align="center" align="center" label="操作" width="100")
      template(slot-scope="scope")
        el-menu(:collapse="true")
          el-submenu(index="1")
            template(slot="title")
              i.el-icon-more(style="color: #02b90d;")
            el-menu-item-group
              el-menu-item(index="1-1" @click="addOrUpdateHandle(scope.row.id)" :disabled="scope.row.status !== 10") 修改
              el-menu-item(index="1-2" @click="publishLive(scope.row.id)" :disabled="scope.row.status !== 10") 发布
              el-menu-item(index="1-3" @click="doneLive(scope.row.id)" :disabled="scope.row.status !== 20") 下播
  el-pagination(
    :current-page="searchData.page"
    :page-size="searchData.rows"
    :page-sizes="[10, 20, 50, 100]"
    :total="totalPage"
    @size-change="sizeChangeHandle"
    @current-change="currentChangeHandle"
    layout="total, sizes, prev, pager, next, jumper"
  )
  //- ==================================================新建&修改dialog==================================================
  el-dialog(
      :title="`${addOrUpdateTitle[isAddOrUpdate]}`"
      class="el-dialog-custom"
      :visible.sync="addOrUpdateVisible"
      :close-on-click-modal="false"
      :append-to-body="true"
  )
    el-card(shadow="never")
      div(slot="header")
        font(style="font-weight: bold; font-size: 18px;") 直播相关配置
      div
        el-form(:model="formData" :rules="formRules" ref="formData" label-width="120px")
          el-form-item(label="比赛ID：" prop="businessCode")
            el-input(v-model="formData.businessCode" style="width: 300px; margin-right: 10px;" placeholder="请选择比赛" disabled)
            el-button(icon="el-icon-document-copy" :disabled="!formData.businessCode" @click="copyCode(formData.businessCode)") 一键复制
          el-form-item(label="直播名称：" prop="liveName")
            el-input(v-model="formData.liveName" style="width: 300px; margin-right: 10px;" placeholder="请输入直播名称" clearable)
            el-button(icon="el-icon-search" :disabled="isAddOrUpdate === 2" @click="chooseMatch") 选择比赛
          el-form-item(label="频道：" prop="streamId")
            el-select(style="width: 300px;" v-model="formData.streamId" placeholder="请选择频道" clearable :disabled="isAddOrUpdate === 2")
              el-option(v-for="(item, index) in streamList" :key="index" :label="item.streamName" :value="item.id" :disabled="item.status === 20")
          el-form-item(label="直播时间：" prop="__liveTime__")
            el-date-picker(
              style="width: 500px;"
              v-model="formData.__liveTime__"
              range-separator="至"
              type="datetimerange"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              format="yyyy-MM-dd HH:mm"
              value-format="yyyy-MM-dd HH:mm"
              clearable
            )
    span.dialog-footer(slot="footer")
      el-button(@click="closeAddOrUpdateDialog") 取 消
      el-button(type="primary" :disabled="submitDialogDisabled" @click="submitDialog") 提 交
  //- ==================================================选择比赛dialog==================================================
  el-dialog(
      title="选择比赛"
      class="el-dialog-custom-match"
      top="5vh"
      width="90%"
      :visible.sync="chooseMatchVisible"
      :close-on-click-modal="false"
      :append-to-body="true"
  )
    div(style="margin-bottom: 20px;")
      el-input(v-model="searchMatchData.matchId" style="width: 20%; margin-right: 10px;" placeholder="请输入比赛ID" clearable)
      el-input(v-model="searchMatchData.matchName" style="width: 20%; margin-right: 10px;" placeholder="请输入比赛名称" clearable)
      el-select(v-model="searchMatchData.userGroupId" style="width: 20%; margin-right: 10px;" placeholder="请选择主办方" filterable clearable)
        el-option(v-for="(item, index) in sysOrgList" :key="index" :label="item.name" :value="item.orgId")
      el-date-picker(v-model="searchMatchData.__matchTimeRangeArray__" type="daterange" value-format="yyyy-MM-dd" start-placeholder="开始日期" end-placeholder="结束日期" style="width: 20%; margin-right: 10px;")
      el-button(@click="searchMatch" icon="el-icon-search") 查询
      el-button(@click="resetSearchMatchData" icon="el-icon-refresh-right") 重置
    el-table(class="matchData-table" :data="matchData" ref="matchData" v-loading="matchTableLoading" border :header-cell-class-name="headerCellClassName" @select="checkMatch" @row-click="checkMatch2")
      el-table-column(type="selection" align="center")
      el-table-column(prop="matchId" label="比赛ID" align="center" width="160")
      el-table-column(prop="matchName" label="比赛名称" align="center")
      el-table-column(prop="orgName" label="主办方" align="center")
      el-table-column(prop="ctType" header-align="center" align="center" label="比赛类型" width="80")
          template(slot-scope="scope")
              font(v-if="scope.row.ctType === 1") 常规赛
              font(v-if="scope.row.ctType === 2") 月度赛
              font(v-if="scope.row.ctType === 3") 季度赛
              font(v-if="scope.row.ctType === 4") 年度总决赛
      el-table-column(prop="applySize" header-align="center" align="center" label="签位" width="60")
          template(slot-scope="scope")
              span() {{ scope.row.joinCount }}/{{ scope.row.applySize }}
      el-table-column(prop="level" header-align="center" align="center" label="比赛级别" width="100")
      el-table-column(prop="matchStartTime" header-align="center" align="center" label="比赛时间" width="140")
      el-table-column(prop="refereeName" header-align="center" align="center" label="裁判" :show-overflow-tooltip="true" width="80")
          template(slot-scope="scope")
              font {{ scope.row.refereeName || "-" }}
      el-table-column(prop="matchStatus" header-align="center" align="center" label="状态" width="100")
          template(slot-scope="scope")
              font(v-if="scope.row.matchStatus === 1" )
                span.danger()
                span() &nbsp; 未审核
              font(v-if="scope.row.matchStatus === 2 && new Date(scope.row.matchSignStartTime).getTime()>new Date().getTime()")
                span.success()
                span() &nbsp; 已发布
              font(v-if="scope.row.matchStatus === 2 && new Date(scope.row.matchSignStartTime).getTime()<=new Date().getTime() && new Date().getTime()<=new Date(scope.row.matchSignEndTime).getTime() && scope.row.joinCount<scope.row.applySize")
                span.warning()
                span() &nbsp; 报名中
              font(v-if="scope.row.matchStatus === 2 && new Date(scope.row.matchSignStartTime).getTime()<=new Date().getTime() && new Date().getTime()<=new Date(scope.row.matchSignEndTime).getTime() && scope.row.joinCount>=scope.row.applySize && scope.row.bench==1")
                span.warning()
                span() &nbsp; 报满可替
              font(v-if="scope.row.matchStatus === 2 && new Date(scope.row.matchSignStartTime).getTime()<=new Date().getTime() && new Date().getTime()<=new Date(scope.row.matchSignEndTime).getTime() && scope.row.joinCount>=scope.row.applySize && scope.row.bench==0")
                span.warning()
                span() &nbsp; 已报满
              font(v-if="scope.row.matchStatus === 2 && new Date().getTime()>new Date(scope.row.matchSignEndTime).getTime() &&  new Date().getTime()<new Date(scope.row.matchStartTime).getTime()")
                span.warning()
                span() &nbsp; 报名结束
              font(v-if="scope.row.matchStatus === 2 &&  new Date().getTime()>new Date(scope.row.matchStartTime).getTime()")
                span.warning()
                span() &nbsp; 已开赛
              font(v-if="scope.row.matchStatus === 3")
                span.warning()
                span() &nbsp; 已取消
              font(v-if="scope.row.matchStatus === 4")
                span.warning()
                span() &nbsp; 已结束
              font(v-if="scope.row.matchStatus === 5")
                span.warning()
                span() &nbsp; 已拒绝
      el-table-column(prop="recommend" header-align="center" align="center" label="首页推荐" width="80")
          template(slot-scope="scope")
              font(v-if="scope.row.recommend == 0") 未推荐
              font(v-if="scope.row.recommend == 1") 已推荐
    el-pagination(
      :current-page="searchMatchData.page"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="searchMatchData.rows"
      :total="matchData_totalPage"
      @size-change="sizeChangeHandle_matchData"
      @current-change="currentChangeHandle_matchData"
      layout="total, sizes, prev, pager, next, jumper"
    )
    span.dialog-footer(slot="footer")
      el-button(@click="closeChooseMatchDialog") 取 消
      el-button(type="primary" @click="confirmDialog") 确 定
</template>

<script>
export default {
  name: 'news-live',
  data () {
    return {
      sysOrgList: [], // 主办方列表
      streamList: [], // 频道列表
      searchData: { // 搜索form
        liveName: '',
        page: 1,
        rows: 10
      },
      tableLoading: false,
      tableData: [],
      totalPage: 0,
      isAddOrUpdate: 1, // 1-新建 2-修改
      addOrUpdateVisible: false, // 新建dialog
      addOrUpdateTitle: {
        1: '新建',
        2: '修改'
      }, // 新建dialog
      submitDialogDisabled: false, // 新建dialog提交按钮禁用
      formData: { // 新建form
        id: '',
        sourceType: 10,
        businessId: '',
        businessCode: '',
        liveName: '',
        streamId: '',
        __liveTime__: null,
        streamStartTime: '',
        streamEndTime: ''
      },
      formRules: { // 新建form校验
        businessCode: [{ required: true, message: '请选择比赛！' }],
        liveName: [{ required: true, message: '直播名称不能为空！' }],
        streamId: [{ required: true, message: '频道不能为空！' }],
        __liveTime__: [{ required: true, message: '直播时间不能为空！' }]
      },
      chooseMatchVisible: false, // 选择比赛dialog
      searchMatchData: { // 选择比赛搜索form
        page: 1,
        rows: 10,
        matchId: '',
        matchName: '',
        userGroupId: '',
        __matchTimeRangeArray__: [],
        ctStrTime: '',
        ctEndTime: ''
      },
      matchTableLoading: false,
      matchData: [],
      matchData_totalPage: 0,
      chooseMatchData: {} // 选中的比赛
    }
  },
  mounted () {
    this.getSysOrgList()
    this.getDataList()
    this.getStreamList()
  },
  methods: {
    // 获取主办方列表
    getSysOrgList () {
      this.$http({
        url: this.$http.adornUrl('/sysOrg/list'),
        method: 'get'
      }).then((res) => {
        if (res && res.code === 0) {
          this.sysOrgList = res.list
        }
      })
    },
    // 获取频道列表
    getStreamList () {
      this.$http({
        url: this.$http.adornUrl('/live/stream/config/List'),
        method: 'get'
      }).then((res) => {
        if (res && res.code === 0) {
          this.streamList = res.data
        }
      })
    },
    // 获取列表数据
    getDataList () {
      this.tableLoading = true
      this.$http({
        url: this.$http.adornUrl('/live/detail/queryPage'),
        method: 'post',
        data: this.searchData
      }).then(res => {
        if (res && res.code === 0) {
          this.tableData = res.pageInfo.list
          this.totalPage = res.pageInfo.total
        } else {
          this.tableData = []
          this.totalPage = 0
        }
      }).finally(() => {
        this.tableLoading = false
      })
    },
    // 查询
    queryList () {
      this.searchData.page = 1
      this.getDataList()
    },
    // 表格每页数据量改变
    sizeChangeHandle (val) {
      this.searchData.rows = val
      this.searchData.page = 1
      this.getDataList()
    },
    // 表格翻页
    currentChangeHandle (val) {
      this.searchData.page = val
      this.getDataList()
    },
    // 新建&修改
    addOrUpdateHandle (id = '') {
      this.addOrUpdateVisible = true
      this.$refs.formData && this.$refs.formData.resetFields()
      this.formData.id = ''
      this.formData.__liveTime__ = null
      if (id) {
        this.isAddOrUpdate = 2
        this.$http({
          url: this.$http.adornUrl('/live/getDetail'),
          method: 'get',
          params: this.$http.adornParams({ id })
        }).then(res => {
          if (res && res.code === 0) {
            const { businessId, businessCode, liveName, streamId, streamStartTime, streamEndTime } = res.data
            this.formData = {
              id,
              sourceType: 10,
              businessId,
              businessCode,
              liveName,
              streamId,
              __liveTime__: [streamStartTime, streamEndTime],
              streamStartTime: '',
              streamEndTime: ''
            }
          }
        })
      } else {
        this.isAddOrUpdate = 1
      }
    },
    // 打开选择比赛dialog
    chooseMatch () {
      this.matchData = []
      this.chooseMatchVisible = true
      this.resetSearchMatchData()
      this.searchMatch()
    },
    // 新建&修改dialog关闭
    closeAddOrUpdateDialog () {
      this.addOrUpdateVisible = false
    },
    // 选择比赛dialog关闭
    closeChooseMatchDialog () {
      this.chooseMatchVisible = false
    },
    // 新建&修改提交
    submitDialog () {
      this.$refs.formData.validate(valid => {
        if (valid) {
          this.formData.streamStartTime = this.formData.__liveTime__[0]
          this.formData.streamEndTime = this.formData.__liveTime__[1]
          this.submitDialogDisabled = true
          this.$http({
            url: this.$http.adornUrl(`/live/detail/saveOrUpdate`),
            method: 'post',
            data: this.formData
          }).then(res => {
            if (res && res.code === 0) {
              this.closeAddOrUpdateDialog()
              this.$message.success(`${this.addOrUpdateTitle[this.isAddOrUpdate]}成功`)
              this.queryList()
              // 新建成功后, 会有一个频道被占用, 需要重新刷新频道列表
              if (this.isAddOrUpdate === 1) {
                this.getStreamList()
              }
            }
          }).finally(() => {
            this.submitDialogDisabled = false
          })
        }
      })
    },
    // 选择比赛dialog-隐藏表格全选框
    headerCellClassName ({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        return 'selection-checkbox'
      }
    },
    // 获取比赛列表
    getMatchDataList () {
      this.matchTableLoading = true
      if (this.searchMatchData.__matchTimeRangeArray__ && this.searchMatchData.__matchTimeRangeArray__.length > 0) {
        this.searchMatchData.ctStrTime = this.searchMatchData.__matchTimeRangeArray__[0]
        this.searchMatchData.ctEndTime = this.searchMatchData.__matchTimeRangeArray__[1]
      } else {
        this.searchMatchData.ctStrTime = ''
        this.searchMatchData.ctEndTime = ''
      }
      this.$http({
        url: this.$http.adornUrl(`/ctCompetition/queryCompetitionOfCarousel`),
        method: 'post',
        data: this.searchMatchData
      }).then(res => {
        this.matchTableLoading = false
        if (res && res.code === 0) {
          this.matchData = res.page.rows
          this.matchData_totalPage = res.page.total
          // 还原勾选
          setTimeout(() => {
            if (this.formData.businessCode) {
              for (let i = 0; i < this.matchData.length; i++) {
                if (this.matchData[i].id === this.formData.businessCode) {
                  this.$refs.matchData.toggleRowSelection(this.matchData[i], true)
                  break
                }
              }
            }
          }, 0)
        } else {
          this.matchData = []
          this.matchData_totalPage = 0
        }
      })
    },
    // 比赛列表查询
    searchMatch () {
      this.searchMatchData.page = 1
      this.getMatchDataList()
    },
    // 比赛列表搜索条件重置
    resetSearchMatchData () {
      this.searchMatchData = {
        page: 1,
        rows: 10,
        matchId: '',
        matchName: '',
        userGroupId: '',
        __matchTimeRangeArray__: [],
        ctStrTime: '',
        ctEndTime: ''
      }
      this.getMatchDataList()
    },
    // 比赛列表-表格每页数据量改变
    sizeChangeHandle_matchData (val) {
      this.searchMatchData.rows = val
      this.searchMatchData.page = 1
      this.getMatchDataList()
    },
    // 比赛列表-表格翻页
    currentChangeHandle_matchData (val) {
      this.searchMatchData.page = val
      this.getMatchDataList()
    },
    // 比赛列表-选择一个比赛
    checkMatch (selection, row) {
      this.$refs.matchData.clearSelection()
      this.$refs.matchData.toggleRowSelection(row)
      this.chooseMatchData = row
    },
    // 比赛列表-选择一个比赛
    checkMatch2 (row) {
      this.$refs.matchData.clearSelection()
      this.$refs.matchData.toggleRowSelection(row)
      this.chooseMatchData = row
    },
    // 比赛列表-确定选择
    confirmDialog () {
      if (this.chooseMatchData.id) {
        this.formData.businessId = this.chooseMatchData.id
        this.formData.businessCode = this.chooseMatchData.matchId
        this.formData.liveName = this.chooseMatchData.matchName
        this.chooseMatchData = {}
      }
      this.chooseMatchVisible = false
    },
    // 复制
    async copyCode (code) {
      try {
        await navigator.clipboard.writeText(code)
        this.$message.success('复制成功')
      } catch (err) {
        this.$message.error('复制失败，请重试')
      }
    },
    // 发布
    publishLive (liveId) {
      this.$confirm('确定将此频道直播发布？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.$http({
          url: this.$http.adornUrl(`/live/publish`),
          method: 'get',
          params: this.$http.adornParams({ liveId })
        }).then(res => {
          if (res && res.code === 0) {
            this.$message.success('发布成功')
            this.queryList()
          }
        })
      })
    },
    // 下播
    doneLive (liveId) {
      this.$confirm('确定将此频道直播下播？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.$http({
          url: this.$http.adornUrl(`/live/down`),
          method: 'get',
          params: this.$http.adornParams({ liveId })
        }).then(res => {
          if (res && res.code === 0) {
            this.$message.success('下播成功')
            this.queryList()
          }
        })
      })
    },
    // 前往比赛
    goCompetition (matchId, matchType) {
      if (matchType === '1') {
        this.$router.push({
          path: '/ct/competition/level',
          query: { matchId }
        })
      }
      if (matchType === '2') {
        this.$router.push({
          path: '/ct/competition/club',
          query: { matchId }
        })
      }
      if (matchType === '-1') {
        this.$router.push({
          path: '/ct/competition/teenagers',
          query: { matchId }
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
/* 操作三点 菜单样式 */
@import "../../css/opr3dot.css";

.el-dialog-custom-match {
  overflow: hidden !important;
}

.el-dialog-custom-match /deep/ .el-dialog__body {
  height: 70vh;
  overflow: auto;
}

.el-dialog-custom-match /deep/ .el-dialog__footer {
  border-top: 1px solid #E9E9E9;
}

.matchData-table /deep/ .selection-checkbox > .cell {
  display: none !important;
}

.live-name {
  color: #02B90D;
  font-weight: 500;
  font-family: '';
  cursor: pointer;

  &:hover {
    color: #35C73D;
  }

  &:active {
    color: #02A70C;
  }
}
</style>
